import { useState } from 'react'

// Pre-donation comment state. The donor composes their comment via
// the link → modal flow on Comment.jsx; useComment holds the
// committed value here, contributes it to the order draft as
// `donor_comment_draft`, and FinalizeChargeSucceededJob promotes the
// draft to a real Comment record on charge success (see
// Order#donor_comment_draft + the job's publish_donor_comment_draft).
//
// `enabled` mirrors the partner's postDonationComment config flag —
// the same one v6 uses to gate the post-donation Comment.jsx — so a
// partner who hasn't enabled comments has the section hidden
// entirely. Mirrors useCompanyContribution's shape: when disabled,
// draftOrderProps no-ops so the draft request stays clean of the
// field.
const useComment = ({ enabled }) => {
  const [ value, setValue ] = useState('')
  const [ submitted, setSubmitted ] = useState(false)

  const save = text => {
    const trimmed = text.trim()
    setValue(trimmed)
    setSubmitted(trimmed.length > 0)
  }

  // Donor opted to remove a previously-saved draft comment. Resets
  // both the value and the submitted flag so the next draft request
  // omits donor_comment_draft entirely (null on Order rather than
  // empty string keeps the data jsonb tidy).
  const remove = () => {
    setValue('')
    setSubmitted(false)
  }

  const draftOrderProps = () =>
    enabled && submitted && value
      ? { donor_comment_draft: value }
      : {}

  return { enabled, value, submitted, save, remove, draftOrderProps }
}

export default useComment
